import React from 'react';
import { useSelector } from 'react-redux';
import { emitEvent, updateParent } from '../../lib/modal';
import useSessionEntity from '../../hooks/useSessionEntity';

export default function ReturnToMerchant({ merchant, redirect }) {
  const session = useSelector(state => state.sessions.get('session'));
  const user = useSessionEntity('user');

  const onClick = () => {
    if (session && session.mode === 'modal') {
      emitEvent(user, {
        action: 'completed'
      });
    }

    if (redirect) {
      return redirect();
    } else if (session.mode === 'modal') {
      updateParent('cancel', null);
    } else {
      window.location.href = merchant.url;
    }
  }

  return (
    <>
      {merchant && merchant.url &&
        <button
          style={{ maxWidth: "400px", margin: "0 auto", lineHeight: "30px", marginBottom: "30px" }}
          className="button is-ck-blue is-large is-fullwidth has-text-weight-bold"
          onClick={onClick}
        >
          Return to {merchant.name}
        </button>
      }
    </>
  );
}
